import {
  get, post, update, hapus, upload, download
} from './helpers'

// API GENERAL
export function getAssessment($data) {
  return get(`/peserta/assessment`, $data)
}

export function patchAssessment($data) {
  return update('peserta/assessment', $data)
}

export function updateStatusAssessment() {
  return update('peserta/update-assessment')
}